import commonConstant from '../../common/_commonConstant';
import {isWeekDay} from "../FormatDate/FormatDate";

export const memberNote = (getBuildingConfig, vehicleType) => {
  try {
    return (
      getBuildingConfig.buildingConfig.buildingConfig.content[commonConstant.defaultLanguage][vehicleType.toLocaleLowerCase()].tenantMemberParkingNote ?
        `* ${getBuildingConfig.buildingConfig.buildingConfig.content[commonConstant.defaultLanguage][vehicleType.toLocaleLowerCase()].tenantMemberParkingNote}`
        : null
    );
  } catch (error) {
    return null;
  }
};

export const buildingID = getBuildingByRefNo => {
  try {
    return getBuildingByRefNo.building.buildingID ? getBuildingByRefNo.building.buildingID : null;
  } catch (error) {
    return null;
  }
};

export const overnightTimeStart = (getBuildingConfig, vehicleType) => {
  try {
    return (
      getBuildingConfig.buildingConfig.buildingConfig.config[vehicleType.toLocaleLowerCase()].parking.overnight.timeStart ?
        getBuildingConfig.buildingConfig.buildingConfig.config[vehicleType.toLocaleLowerCase()].parking.overnight.timeStart
        : null
    );
  } catch (error) {
    return null;
  }
};

export const overnightTimeEnd = (getBuildingConfig, vehicleType) => {
  try {
    return (
      getBuildingConfig.buildingConfig.buildingConfig.config[vehicleType.toLocaleLowerCase()].parking.overnight.timeEnd ?
        getBuildingConfig.buildingConfig.buildingConfig.config[vehicleType.toLocaleLowerCase()].parking.overnight.timeEnd
        : null
    );
  } catch (error) {
    return null;
  }
};

export const overnightTime = (getBuildingConfig, vehicleType) => {
  try {
    return (
      overnightTimeStart(getBuildingConfig, vehicleType) && overnightTimeEnd(getBuildingConfig, vehicleType) ?
        `* ตั้งแต่ ${overnightTimeStart(getBuildingConfig, vehicleType)} น. - ${overnightTimeEnd(getBuildingConfig, vehicleType)} น.`
        : null
    );
  } catch (error) {
    return null;
  }
};

export const buildingCompanyName = getBuildingByRefNo => {
  try {
    return getBuildingByRefNo.building.buildingInfo.buildingCompanyName ? getBuildingByRefNo.building.buildingInfo.buildingCompanyName : null;
  } catch (error) {
    return null;
  }
};

export const buildingTaxID = getBuildingByRefNo => {
  try {
    return getBuildingByRefNo.building.buildingInfo.buildingTaxID ? getBuildingByRefNo.building.buildingInfo.buildingTaxID : null;
  } catch (error) {
    return null;
  }
};

export const buildingPosID = getBuildingByRefNo => {
  try {
    return getBuildingByRefNo.building.buildingInfo.buildingPosID ? getBuildingByRefNo.building.buildingInfo.buildingPosID : null;
  } catch (error) {
    return null;
  }
};

export const buildingRefNo = getBuildingConfig => {
  try {
    return getBuildingConfig.buildingRefNo ? getBuildingConfig.buildingRefNo : getBuildingConfig.building.buildingRefNo ? getBuildingConfig.building.buildingRefNo : null;
  } catch (error) {
    return null;
  }
};

export const parkingDayConfig = (configs, parkingGateName) => {
  const dateNow = new Date();
  const parkingDayConfigs = configs.parkingDayConfigs.filter(item => item.parkingZone.includes(parkingGateName));
  const customParkingDayConfigs = parkingDayConfigs.filter(item => item.dayType === commonConstant.dayTypeCustom);

  if (customParkingDayConfigs.length > 0) {
    const dateNowMidnight = new Date(dateNow.setHours(0,0,0, 0));
    const todayCustomOayParkingConfig = customParkingDayConfigs.filter(item => new Date(item.date).toString() === dateNowMidnight.toString());
    if (todayCustomOayParkingConfig.length > 0) {
      return { ...todayCustomOayParkingConfig[0] };
    }
  }

  if (isWeekDay(dateNow)) {
    return parkingDayConfigs.find(item => item.dayType === commonConstant.dayTypeWeekday);
  } else {
    return parkingDayConfigs.find(item => item.dayType === commonConstant.dayTypeWeekend);
  }
};
